module.exports = "/assets/data/00bee60a175de1061df8c904a354913d-CH4.data.json";